<template lang="html">
    <fe-chip close @click="editFilter(filter)" @click:close="unsetFilter(filter)" :class="{highlight:highlight}">
        {{filter.chipText}}
        <template #tooltip>
            <div class="filter-chip-tooltip-content">
                <v-list-item v-for="(value, label) in filter.tooltipData" :key="label" dark dense>
                    <v-list-item-content>
                        <v-list-item-title>{{ label }}</v-list-item-title>
                        <v-list-item-subtitle class="filter-chip-tooltip-subtitle">
                            <span class="mr-1">{{ value }}</span>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </div>
        </template>
    </fe-chip>
</template>

<script>
import Group from '../Group'
import { mapLocalState } from '@/util/vuexHelper'

export default {
    name: 'ActiveFilterChip',
    inject: ['localStore'],

    props: ['filter'],

    data() {
        return {}
    },
    computed: {
        ...mapLocalState(['params','charts','groupers','activeGrouping','highlightedFilter']),
        highlight() {
            return this.highlightedFilter === this.filter.id
        },
    },
    methods: {
        // On chip click: open More Filters to the matching section, or call the filter editor's load/openDropdown for standalone panels.
        editFilter(filter) {
            const moreFiltersSectionKey = this.getMoreFiltersSectionKey(filter.type)
            if (moreFiltersSectionKey) {
                this.localStore.state.openMoreFiltersToSection = moreFiltersSectionKey
                return
            }
            if (filter.editor && typeof filter.editor.load === 'function') {
                filter.editor.load(filter)
                if (typeof filter.editor.openDropdown === 'function') {
                    filter.editor.openDropdown()
                }
                return
            }
            console.warn('Editor not available for filter', filter?.id)
        },
        // Maps a filter type from params.filters to the More Filters expansion-panel section key (e.g. el_status → 'ell').
        getMoreFiltersSectionKey(filterType) {
            const map = {
                course: 'course',
                disability: 'disability',
                el_status: 'ell',
                elp_level: 'ell',
                ethnicity: 'ethnicity',
                meal_status: 'meal_status',
                form: 'form',
            }
            return map[filterType] || null
        },
        unsetFilter(filter) {
            this.groupers = this.groupers.filter(x => x !== filter.grouper)
            this.params.filters = this.params.filters.filter(x => x !== filter)
            if(this.activeGrouping.id === filter.id || !this.activeGrouping.grouper) {
                this.activeGrouping.grouper = null
            }
            const editor = filter?.editor
            if (editor) {
                if (typeof editor.clearFilter === 'function') {
                    editor.clearFilter()
                } else if (typeof editor.clear === 'function') {
                    editor.clear()
                }
                editor.oldFilter = null
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .v-tooltip__content::v-deep .v-list {
        margin: 0 !important;
        padding: 0 !important;
    }
    .highlight::v-deep .v-chip {
        border-color: black;
        box-shadow: 0 0 3px 3px rgb(83,160,228);
    }
</style>

<style lang="scss">
.filter-chip-tooltip-subtitle {
    white-space: normal;
    overflow: visible;
}
</style>




<!-- <template>
    <v-tooltip bottom>
        <template v-slot:activator>
            <v-chip
                class="breadcrumb-chip"
                close
                @click="$emit('editFilter', filter)"
                @input="$emit('unsetFilter', filter)"
            >
                <span class="text-truncate text-no-wrap slot-text" >
                    {{ filter.breadcrumbText }}
                </span>
            </v-chip>
        </template>
        <v-list two-line dense dark>
            <v-list-item v-for="(param, index) in filter.params" :key="index">
                <v-list-item-content>
                    <v-list-item-title>{{ param.label }}</v-list-item-title>
                    <v-list-item-subtitle>
                        <span
                            class="mr-1"
                        >
                            {{chipText(param)}}
                        </span>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-tooltip>
</template>

<script>
export default {
    name: 'ActiveFilterChip',
    props: ['filter', 'truncateBreadcrumbBy'],
    data() {
        return {}
    },
    methods: {
        chipText(x) {
            if(Array.isArray(x.value)) {
                return x.value.map(y=>y.name || y.value).join(', ')
            } else {
                return x.name || x.value
            }
        }
    }
}
</script>

<style>
</style> -->
